import { useEntity } from '@uswitch/ev-utils/context/selectors';
import { RichText } from '@uswitch/ev-core/react';
import { Button } from '@uswitch/spark';
import { UswChevronLargeDown } from '@uswitch/spark-icons/usw';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var contentHidden = {
  height: 'unset',
  opacity: '1',
  position: 'relative',
  maxHeight: '200px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: ['3', '3', '2'],
  WebkitBoxOrient: 'vertical'
};
var contentVisible = {
  height: 'auto',
  overflow: 'visible',
  position: 'relative',
  maxHeight: 'auto',
  textOverflow: 'initial',
  WebkitLineClamp: ''
};

var AccordionPreview = function AccordionPreview(_ref) {
  var entity = _ref.entity;

  var _useEntity = useEntity(entity),
      content = _useEntity.content,
      title = _useEntity.title;

  return _jsxs("div", {
    sx: {
      ':not(:first-of-type)': {
        margin: '32px 0 0 0'
      }
    },
    "data-accordion-preview": "accordion-preview",
    children: [_jsx("div", {
      sx: {
        fontSize: ['18px', '18px', '24px'],
        lineHeight: ['24px', '24px', '32px'],
        fontWeight: '700',
        padding: '0 0 16px 0'
      },
      children: title
    }), _jsx("div", {
      "data-accordion-preview-content": "accordion-preview-content",
      sx: {
        '&.ev-accordion-preview-visible': contentVisible,
        '&.ev-accordion-preview-hidden': contentHidden
      },
      className: "ev-accordion-preview-hidden",
      children: _jsx(RichText, {
        content: content,
        style: {
          '> p': {
            color: '#575761'
          }
        }
      })
    }), _jsx(Button, {
      variant: "secondary",
      rightIcon: _jsx(UswChevronLargeDown, {
        sx: {
          strokeWidth: '0.25em'
        }
      }),
      sx: {
        margin: '16px 0 0 0',
        minWidth: '145px'
      },
      "data-accordion-preview-button": "accordion-preview-button",
      "data-accordion-preview-open": false,
      children: "Read more"
    })]
  });
};

export default AccordionPreview;
//# sourceMappingURL=preview.js.map